'use strict';

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var pDebounce = function pDebounce(fn, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!Number.isFinite(wait)) {
    throw new TypeError('Expected `wait` to be a finite number');
  }

  var leadingValue;
  var timer;
  var resolveList = [];
  return function () {
    var _this = this;

    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    return new Promise(function (resolve) {
      var runImmediately = options.leading && !timer;
      clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        var result = options.leading ? leadingValue : fn.apply(_this, arguments_);

        var _iterator = _createForOfIteratorHelper(resolveList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            resolve = _step.value;
            resolve(result);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        resolveList = [];
      }, wait);

      if (runImmediately) {
        leadingValue = fn.apply(_this, arguments_);
        resolve(leadingValue);
      } else {
        resolveList.push(resolve);
      }
    });
  };
};

pDebounce.promise = function (function_) {
  var currentPromise;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _len2,
        arguments_,
        _key2,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!currentPromise) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", currentPromise);

          case 2:
            _context.prev = 2;

            for (_len2 = _args.length, arguments_ = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              arguments_[_key2] = _args[_key2];
            }

            currentPromise = function_.apply(this, arguments_);
            _context.next = 7;
            return currentPromise;

          case 7:
            return _context.abrupt("return", _context.sent);

          case 8:
            _context.prev = 8;
            currentPromise = undefined;
            return _context.finish(8);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[2,, 8, 11]]);
  }));
};

export default pDebounce;